export default {
    setIsDark (state, payload) {
        state.isDark = payload
    },
    setFusionAuthToken (state, payload) {
        state.fusionAuthToken = payload
    }
}
